<div class="card-container" #container>
    <div class="card-header-wrapper">
        <h3 class="card-title"> {{ customMsgService.translate('inventario') }}</h3>
        <span></span>
    </div>
    <div class="card-component">

        <kendo-grid [kendoGridBinding]="gridView" kendoGridSelectBy="id" [selectedKeys]="mySelection" [pageSize]="30"
            [pageable]="true" [sortable]="true" [groupable]="true" [reorderable]="true" [resizable]="true"
            [height]="690" [columnMenu]="{ filter: true }">

            <!-- Barra de Pesquisa -->
            <ng-template kendoGridToolbarTemplate>
                <kendo-textbox [placeholder]="customMsgService.translate('gridSearch')" kendoTextBox
                    style="width: 230px;" (valueChange)="onFilter($event)">
                </kendo-textbox>

                <!-- Filtro de Local -->
                <kendo-dropdownlist kendoDropDownFilter style="width: 230px;" textField="nome" [(ngModel)]="local"
                    [data]="listLocal" #tipoLocal valueField="id" [defaultItem]="placeHolder">
                </kendo-dropdownlist>

                <!-- Filtro de Armario -->
                <kendo-dropdownlist kendoDropDownFilter style="width: 230px;" textField="nome" [(ngModel)]="armario"
                    [data]="listArmario" #tipoArmario valueField="id" [defaultItem]="escolherArmario">
                </kendo-dropdownlist>

                <!-- Botão Filtrar -->
                <button kendoButton (click)="pesquisar()" themeColor="primary">
                    {{customMsgService.translate('filtrar')}} </button>


                <kendo-grid-spacer></kendo-grid-spacer>

                <!-- Botão exportar Excel -->
                <button kendoGridExcelCommand type="button" [title]="customMsgService.translate('btnExportarExcel')"
                    icon="file-excel" themeColor="warning">
                </button>

                <!-- Botão exportar PDF -->
                <button kendoGridPDFCommand icon="file-pdf" [title]="customMsgService.translate('btnExportarPDF')"
                    themeColor="warning">
                </button>
            </ng-template>

            <!-- Armario -->
            <kendo-grid-column field="nomeArmario" [title]="customMsgService.translate('armario')" [width]="100">
                <ng-template kendoGridCellTemplate let-dataItem>
                        <div class="customer-name"> {{ dataItem.nomeArmario }} </div>
                </ng-template>
            </kendo-grid-column>

            <!-- Artigo -->
            <kendo-grid-column field="nomeArtigo" [title]="customMsgService.translate('artigo')" [width]="120">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span kendoTooltip title="{{customMsgService.translate('artigo')}}: {{dataItem.nomeArtigo}}
{{customMsgService.translate('codigoInterno')}}: {{dataItem.codigoInterno}}
{{customMsgService.translate('codigoFabricante')}}: {{dataItem.codigoFabricante}}">
                        <div class="customer-name"> {{ dataItem.nomeArtigo }} </div>
                    </span>
                </ng-template>
            </kendo-grid-column>

            <!-- Stock -->
            <kendo-grid-column field="stock" [title]="customMsgService.translate('stock')" [width]="120">
            </kendo-grid-column>

            <!-- Quantidade Desejada -->
            <kendo-grid-column field="quantidadeDesejada" [title]="customMsgService.translate('quantidadeDesejada')"
                [width]="120">
            </kendo-grid-column>

            <!-- Quantidade a Remover -->
            <kendo-grid-column field="quantidadeARemover" [title]="customMsgService.translate('quantidadeRemover')"
                [width]="120">
            </kendo-grid-column>

            <!-- Quantidade a Repor -->
            <kendo-grid-column field="quantidadeARepor" [title]="customMsgService.translate('quantidadeRepor')"
                [width]="120">
            </kendo-grid-column>


            <kendo-grid-pdf fileName="{{customMsgService.translate('inventario')}}.pdf" [repeatHeaders]="true"
                [allPages]="true" paperSize="A4" [landscape]="true" [scale]="0.6">
                <kendo-grid-pdf-margin top="2cm" left="1cm" right="1cm" bottom="2cm"></kendo-grid-pdf-margin>
                <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
                    <div class="page-template">
                        <div class="header">

                            <div style="float: left">
                                {{ customMsgService.translate('inventario') }}
                            </div>

                            <style>
                                .custom-font {
                                    font-size: 12px;
                                }
                            </style>

                            <div class="custom-font" style="float: right;">
                                <!-- data e Hora do relatorio-->
                                {{ getdatetime() }}
                            </div>

                        </div>
                        <div class="footer">{{ customMsgService.translate('pagina') }} {{ pageNum }} {{
                            customMsgService.translate('de_') }} {{ totalPages }}</div>
                    </div>
                </ng-template>

                <kendo-grid-column field="nomeArmario" [title]="customMsgService.translate('armario')" [width]="120">
                </kendo-grid-column>

                <kendo-grid-column field="nomeArtigo" [title]="customMsgService.translate('artigo')" [width]="120">
                </kendo-grid-column>

                <kendo-grid-column field="stock" [title]="customMsgService.translate('stock')" [width]="100">
                </kendo-grid-column>

                <kendo-grid-column field="quantidadeDesejada" [title]="customMsgService.translate('quantidadeDesejada')"
                    [width]="100">
                </kendo-grid-column>

                <kendo-grid-column field="quantidadeARemover" [title]="customMsgService.translate('quantidadeRemover')"
                    [width]="100">
                </kendo-grid-column>

                <kendo-grid-column field="quantidadeARepor" [title]="customMsgService.translate('quantidadeRepor')"
                    [width]="100">
                </kendo-grid-column>

            </kendo-grid-pdf>

            <kendo-grid-excel [fetchData]="allData"
                fileName="{{customMsgService.translate('inventario')}}.xlsx"></kendo-grid-excel>

            <div kendoDialogContainer></div>